import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConfigServerService, CustomHttp } from '../../../../core';
import { ClienteAnaliseMercadoRevisaoAbrirRequest, ClienteAnaliseMercadoRevisaoAprovarRequest, ClienteAnaliseMercadoRevisaoFilter, ClienteAnaliseMercadoRevisaoReabrirRequest, ClienteAnaliseMercadoRevisaoRevisarRequest, ClienteAnaliseMercadoRevisaoSearch } from '../adapters';
import { CLIENTES_ANALISES_MERCADOS_REVISOES_API_RESOURCE } from '../consts';

@Injectable({
    providedIn: 'root'
})
export class ClienteAnaliseMercadoRevisaoHttpService {
    private readonly pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/${CLIENTES_ANALISES_MERCADOS_REVISOES_API_RESOURCE}`;
    }

    /** Pesquisa as revisões das Análises de Mercado */
    search(filter: ClienteAnaliseMercadoRevisaoFilter): Observable<ClienteAnaliseMercadoRevisaoSearch[]> {
        // Params
        let params = new HttpParams();
        // Filter
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<ClienteAnaliseMercadoRevisaoSearch[]>(this.pathApi, {params})
                    .pipe(
                        map(revisoes => {
                            if (!revisoes) {
                                return revisoes;
                            }

                            for (let i = 0; i < revisoes.length; i++) {
                                revisoes[i] = ClienteAnaliseMercadoRevisaoSearch.fromJSON(JSON.stringify(revisoes[i]));
                            }

                            return revisoes;
                        })
                    );
    }

    /** Pesquisa uma revisão das Análises de Mercado */
    searchOne(id: number): Observable<ClienteAnaliseMercadoRevisaoSearch> {
        return this.customHttp.get<ClienteAnaliseMercadoRevisaoSearch>(`${this.pathApi}/one/${id}`)
                    .pipe(
                        map(response => {
                            if (!response) {
                                return response;
                            }

                            return ClienteAnaliseMercadoRevisaoSearch.fromJSON(JSON.stringify(response));
                        })
                    );
    }

    /** Pesquisa a revisão aberta das Análises de Mercado RAP */
    searchAberta(ano: number, idRepresentante: number): Observable<ClienteAnaliseMercadoRevisaoSearch> {
        return this.customHttp.get<ClienteAnaliseMercadoRevisaoSearch>(`${this.pathApi}/ano/${ano}/representante/${idRepresentante}/aberta`)
                    .pipe(
                        map(response => {
                            if (!response) {
                                return response;
                            }

                            return ClienteAnaliseMercadoRevisaoSearch.fromJSON(JSON.stringify(response));
                        })
                    );
    }

    /** Pesquisa a revisão atual das Análises de Mercado lançadas por um representante em um ano */
    searchAtual(ano: number, idRepresentante: number): Observable<ClienteAnaliseMercadoRevisaoSearch> {
        return this.customHttp.get<ClienteAnaliseMercadoRevisaoSearch>(`${this.pathApi}/ano/${ano}/representante/${idRepresentante}/atual`)
                    .pipe(
                        map(response => {
                            if (!response) {
                                return response;
                            }

                            return ClienteAnaliseMercadoRevisaoSearch.fromJSON(JSON.stringify(response));
                        })
                    );
    }

    /** Abre uma nova revisão das Análises de Mercado */
    abrir(request: ClienteAnaliseMercadoRevisaoAbrirRequest): Observable<ClienteAnaliseMercadoRevisaoSearch> {
        return this.customHttp.post<ClienteAnaliseMercadoRevisaoSearch>(this.pathApi, request)
                    .pipe(
                        map(response => {
                            if (!response) {
                                return response;
                            }

                            return ClienteAnaliseMercadoRevisaoSearch.fromJSON(JSON.stringify(response));
                        })
                    );
    }

    /** Reabre uma revisão das Análises de Mercado */
    reabrir(request: ClienteAnaliseMercadoRevisaoReabrirRequest): Observable<ClienteAnaliseMercadoRevisaoSearch> {
        return this.customHttp.put<ClienteAnaliseMercadoRevisaoSearch>(`${this.pathApi}/reabrir`, request)
                    .pipe(
                        map(response => {
                            if (!response) {
                                return response;
                            }

                            return ClienteAnaliseMercadoRevisaoSearch.fromJSON(JSON.stringify(response));
                        })
                    );
    }

    /** Revisa as Análises de Mercado */
    revisar(request: ClienteAnaliseMercadoRevisaoRevisarRequest): Observable<ClienteAnaliseMercadoRevisaoSearch> {
        return this.customHttp.put<ClienteAnaliseMercadoRevisaoSearch>(`${this.pathApi}/revisar`, request)
                    .pipe(
                        map(response => {
                            if (!response) {
                                return response;
                            }

                            return ClienteAnaliseMercadoRevisaoSearch.fromJSON(JSON.stringify(response));
                        })
                    );
    }

    /** Aprova uma revisão das Análises de Mercado */
    aprovar(request: ClienteAnaliseMercadoRevisaoAprovarRequest): Observable<ClienteAnaliseMercadoRevisaoSearch> {
        return this.customHttp.put<ClienteAnaliseMercadoRevisaoSearch>(`${this.pathApi}/aprovar`, request)
                    .pipe(
                        map(response => {
                            if (!response) {
                                return response;
                            }

                            return ClienteAnaliseMercadoRevisaoSearch.fromJSON(JSON.stringify(response));
                        })
                    );
    }
}
